import React, { Component } from 'react'
import { Form, Field, FieldArray } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import FieldArrayRows from 'components/Input/FieldArrayRows'
import { variableHelpTextSmall } from '../../utils/variableHelpText'

const ArrayValueField = props => (
  <div className={sLay['layout-row']}>
    <div className={sLay['flex-50']}>
      <Field component={Input} name={`${props.name}.key`} label="Name" validate={[vRequired]} />
    </div>
    <div className={sLay['flex-50']} style={{ marginLeft: '5px' }}>
      <Field
        component={Input}
        name={`${props.name}.value`}
        label="Value"
        validate={[vRequired]}
        info={variableHelpTextSmall}
      />
    </div>
  </div>
)

export default class SendAnalyticsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Send an analytics event through Segment. You can then route this event to your analytics
          provider.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            Learn more.
          </a>
        </div>
        <Field name="name" component={Input} label="Event Name" validate={[vRequired]} />
        <Field
          name="userId"
          component={Input}
          label="User ID"
          validate={[vRequired]}
          info={variableHelpTextSmall}
        />
        <div style={{ padding: '15px 0 10px' }} className={sText.descrip3}>
          Event Properties:
        </div>
        <FieldArray
          name="properties"
          FieldComponent={ArrayValueField}
          component={FieldArrayRows}
          addText="Add properties"
          dontInitialise
        />
        <div style={{ padding: '30px 0 10px' }} className={sText.descrip3}>
          Segment Configuration:
        </div>
        <Field name="sourceId" component={Input} label="Source ID" validate={[vRequired]} />
        <Field name="writeKey" component={Input} label="Write Key" validate={[vRequired]} />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendAnalyticsEvent/SendAnalyticsEventForm.jsx